import { inject, Service } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Service()
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private readonly translateService = inject(TranslateService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(snapshot);

    if (titleKey) {
      this.translateService.get(['pagesTitles.mainTitle', titleKey]).subscribe((titles) => {
        const translatedTitle = titles['pagesTitles.mainTitle']
          ? `${titles['pagesTitles.mainTitle']} - ${titles[titleKey]}`
          : titles[titleKey];
        this.titleService.setTitle(translatedTitle);
      });
    }
  }
}
